export default "__VITE_ASSET__BtG46$AH__"